import { FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { getClubModeratorText } from '@fable/utils'
import { ClubModeratorAvatars } from './ClubModeratorAvatars'
import { Club } from '@fable/types'

interface Props {
  club: Club | null
}

export const ClubDetailModerators = ({ club }: Props) => {
  const { colors } = useTheme()

  return (
    <FlexBox justifyContent="space-between">
      <FlexBox
        className={css`
          width: 100%;
          align-items: flex-start;
        `}
        justifyContent="space-between"
      >
        <div>
          <Text tag="h2" type="header" sizing="XS" color={colors.uiGraphite}>
            <span
              className={css`
                color: ${colors.uiPewterGrey};
              `}
            >
              Moderated by
            </span>
            <br />
            {getClubModeratorText({ club, includePronouns: true })}
          </Text>
        </div>
        <ClubModeratorAvatars club={club} />
      </FlexBox>
    </FlexBox>
  )
}
